{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              -87.83921270250926,
              18.185727795187105
            ],
            [
              -88.02394868515385,
              18.16977175759574
            ],
            [
              -88.0351448053146,
              18.411614336334935
            ],
            [
              -88.49417926778267,
              18.49386411844219
            ],
            [
              -88.86637147497183,
              17.90081365640225
            ],
            [
              -89.14342245055242,
              17.935419882283597
            ],
            [
              -89.22173575881604,
              15.879216124640237
            ],
            [
              -88.91120347727802,
              15.897888197049369
            ],
            [
              -87.22062706365324,
              17.346089414244304
            ],
            [
              -87.83921270250926,
              18.185727795187105
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}